import hrms73eLabels from 'assets/labels/hrms73e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hrms73eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        // codempid: faker.lorem.word(),
        // desc_codempid: faker.name.findName(),
        // dtetrst: moment().format('DD/MM/YYYY'),
        // dtetren: moment().format('DD/MM/YYYY'),
        // val_name: faker.name.findName(),
        // val_date: moment().format('DD/MM/YYYY'),
        // numseq: faker.random.number().toString().substr(0, 1),
        // status: mockStatus[staappr],
        // staappr: ''
        dteyear: moment().format('YYYY'),
        codcours: faker.random.number().toString().substr(0, 1),
        numclseq: faker.random.number().toString().substr(0, 1),
        codcomp: '',
        codempid: faker.random.number().toString().substr(0, 5),
        desc_codempid: faker.name.findName(),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        codform: faker.lorem.word(),
        val_code: faker.random.number().toString().substr(0, 5),
        val_name: faker.name.findName(),
        val_date: moment().format('DD/MM/YYYY')
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codform: faker.lorem.word(),
      desc_codform: faker.lorem.word(),
      descommt: faker.lorem.word()
    }
    let mockTab1Table2Rows = []
    const mockChoice = [ 'A', 'B', 'C', 'D' ]
    const mockDescChoice = [ 'Excellence', 'Good', 'Normal', 'Bad' ]
    const mockScore = [ '4', '3', '2', '1' ]
    const mockTab1Table2Total = 4
    for (var d = 1; d <= mockTab1Table2Total; d++) {
      mockTab1Table2Rows.push({
        grditem: d,
        grade: mockChoice[d - 1],
        qtyscor: mockScore[d - 1],
        descgrd: mockDescChoice[d - 1],
        definit: ''
      })
    }
    let mockTab1Table1GroupRows = []
    const mockTab1Table1Total = 3
    for (var a = 1; a <= mockTab1Table1Total; a++) {
      let mockTab1Table1ItemRows = []
      const mockTab1Table1ItemTotal = 3
      let mockGroupQtyfscor = 0
      let mockGroupQtyscor = 0
      for (var e = 1; e <= mockTab1Table1ItemTotal; e++) {
        let mockItemQtywgt = Math.floor(Math.random() * 5) + 1
        let mockItemQtyfscor = 4 * mockItemQtywgt
        let mockItemGrditem = Math.floor(mockItemQtyfscor * Math.random())
        let mockItemQtyscor = mockItemGrditem * mockItemQtywgt
        let mockChoiceFiltered = mockTab1Table2Rows.filter((choice) => {
          return choice.grditem === mockItemGrditem
        })
        let mockGrade = ''
        if (mockChoiceFiltered.length > 0) {
          mockGrade = mockChoiceFiltered[0].grade
        }
        mockTab1Table1ItemRows.push({
          numitem: e,
          desc_numitem: 'description ',
          qtyfscor: mockItemQtyfscor,
          qtyscor: mockItemQtyscor,
          grditem: mockItemGrditem,
          grade: mockGrade,
          qtywgt: mockItemQtywgt
        })
        mockGroupQtyfscor += mockItemQtyfscor
        mockGroupQtyscor += mockItemQtyscor
      }
      mockTab1Table1GroupRows.push({
        numgrup: a,
        desc_numgrup: 'หัวข้อเรื่อง',
        qtyfscor: mockGroupQtyfscor,
        qtyscor: mockGroupQtyscor,
        numitem: mockTab1Table1ItemRows
      })
    }

    return {
      tab1: {
        detail: mockTab1,
        table1: {
          total: mockTab1Table1Total,
          rows: mockTab1Table1GroupRows
        },
        table2: {
          total: mockTab1Table2Total,
          rows: mockTab1Table2Rows
        }
      }
    }
  },
  delete () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms73e/mocker.js